import uploadsarticlesnoYouCanTSayThatInCourtimageshutterstock_18833600981600xJpg from "$lib/data/generated/uploads/articles/no-you-can-t-say-that-in-court/image/shutterstock_1883360098 1600x.jpg";

export const uploads = {
  "uploads/articles/no-you-can-t-say-that-in-court/image/shutterstock_1883360098 1600x.jpg": uploadsarticlesnoYouCanTSayThatInCourtimageshutterstock_18833600981600xJpg
};